var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.93921 4.47656C4.53763 5.14671 3.34144 6.18049 2.47529 7.47017C1.60914 8.75986 1.10473 10.2582 1.01462 11.8092C0.92452 13.3601 1.25202 14.9068 1.963 16.2881C2.67398 17.6694 3.74241 18.8348 5.05694 19.6627C6.37148 20.4907 7.88402 20.9509 9.43692 20.9955C10.9898 21.04 12.5263 20.6673 13.8861 19.9161C15.246 19.1649 16.3795 18.0627 17.1685 16.7245C17.9575 15.3862 18.3732 13.8608 18.3722 12.3073H9.68321L5.93921 4.47656Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6811 12.3069H20.0001C20.0035 10.5629 19.5639 8.8465 18.7225 7.31878C17.8811 5.79107 16.6655 4.50205 15.1897 3.5726C13.714 2.64314 12.0263 2.10369 10.285 2.00484C8.54374 1.90598 6.80587 2.25096 5.23438 3.00742L9.6811 12.3069Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.78516 20.2727L9.68244 12.3066",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderIcon);
export default __webpack_public_path__ + "static/media/orderIcon.b78271580595528d2c703861366aa0bd.svg";
export { ForwardRef as ReactComponent };